<template>
  <v-card max-width="960" elevation="0" rounded="xl" class="my-16 mx-auto">
    <v-card-title>
      <v-tooltip right color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :to="{ name: 'complaint-request' }"
            large
            depressed
            fab
            color="nightDark"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon size="32" color="white">{{ icons.mdiArrowLeft }}</v-icon>
          </v-btn>
        </template>
        <span>Geri Git</span>
      </v-tooltip>
      <v-divider vertical class="mx-4" />
      <v-icon large left>
        {{ icons.mdiCommentAlert }}
      </v-icon>

      <span class="text-body-1">
        <u> {{ data.refno }}</u> numaralı şikayet veya isteği

        <v-chip class="ml-2" color="base" outlined>
          <v-icon left>{{ icons.mdiEye }}</v-icon>
          Görüntülüyorsunuz</v-chip
        >
      </span>
    </v-card-title>

    <v-card-text class="my-6">
      <v-container>
        <v-row>
          <v-col md="2">
            <v-tooltip top color="chip" v-if="data.fileUrl">
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  v-bind="attrs"
                  v-on="on"
                  height="110"
                  @click="downloadFile(data.fileUrl)"
                  color="info"
                  flat
                  rounded="xl"
                  class="d-flex align-center justify-center"
                >
                  <div>
                    <v-icon size="60"> {{ icons.mdiDownload }}</v-icon>
                  </div>
                </v-card>
              </template>
              <span>Ekli Dosyayı İndir</span>
            </v-tooltip>

            <v-tooltip top color="chip" v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  v-bind="attrs"
                  v-on="on"
                  height="110"
                 
                  outlined
                  flat
                  rounded="xl"
                  class="d-flex align-center justify-center"
                >
                  <div>
                    <v-icon size="60"> {{ icons.mdiPaperclipOff }}</v-icon>
                  </div>
                </v-card>
              </template>
              <span>Ekli Dosya Yok</span>
            </v-tooltip>
          </v-col>
          <v-col md="4">
            <v-card height="110" outlined rounded="xl">
              <v-card-text class="pb-2">
                <v-icon left>
                  {{ icons.mdiCompassOutline }}
                </v-icon>
                <span class="text-caption">İlgili Birim</span>
              </v-card-text>
              <v-card-text>
                <div class="info--text text-h6 font-weight-bold">
                  {{ data.unit }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col md="6">
            <v-card height="110" outlined rounded="xl">
              <v-card-text class="pb-2">
                <v-icon left>
                  {{ icons.mdiCalendarClock }}
                </v-icon>
                <span class="text-caption">Kayıt Tarihi</span>
              </v-card-text>
              <v-card-text class="">
                <div class="text-h6 font-weight-bold">
                  {{ data.createdatetime | moment("DD MMMM YYYY, dddd HH:mm") }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-9 mb-3">
          <v-col>
            <v-card min-height="120" color="chip" rounded="xl" class="pa-6">
              <v-card-text class="text-h5 white--text font-weight-black">
                {{ data.stext }}
              </v-card-text>
              <v-card-text class="pb-1 text-subtitle-1" v-html="data.message" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { useRouter } from "@core/utils";

import {
  mdiArrowLeft,
  mdiEye,
  mdiCompassOutline,
  mdiPaperclipOff,
  mdiCalendarClock,
  mdiDownload,
  mdiCommentAlert,
} from "@mdi/js";
import { onMounted, ref } from "@vue/composition-api";

export default {
  setup() {
    const { route, router } = useRouter();
    const data = ref({
      id: "",
      refno: "",
      stext: "",
      message: "",
      unit: "",
      createdatetime: "",
      fileUrl: "",
    });

    const downloadFile = (file) => {
      window.open(file, "_blank");
    };
    onMounted(() => {
      if (route.value.params.item) {
        data.value = route.value.params.item;
      } else {
        router.push({ name: "complaint-request" });
      }
    });

    return {
      data,
      downloadFile,
      icons: {
        mdiArrowLeft,
        mdiCompassOutline,
        mdiCommentAlert,
        mdiPaperclipOff,
        mdiEye,
        mdiDownload,
        mdiCalendarClock,
      },
    };
  },
};
</script>

<style></style>
